/**
 * Converts a given string to [snake case](https://en.wikipedia.org/wiki/Snake_case)
 *
 * @param  {string} str The string to convert
 * @return {string} The converted string
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * toSnakeCase(`fooBar`); // foo_bar
 * toSnakeCase(`FOO`); // f_o_o
 */
const toSnakeCase = (str) =>
  str
    .split(/(?=[A-Z])/)
    .join(`_`)
    .toLowerCase();

/** @component */
export default toSnakeCase;
